export const hcpLicensesSectionStyles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: 1,
		width: '100%'
	},

	cardsContainer: {
		border: '1px solid var(--mui-palette-divider)',
		borderRadius: 1,
		minWidth: 0
	},

	addNewCardButton: {
		display: 'flex',
		justifyContent: 'flex-start',
		width: 'max-content'
	}
};
